const calcCpfDigit = (digits, factorStart) => {
  let sum = 0
  let factor = factorStart
  digits.forEach((digit) => {
    sum += digit * factor
    factor -= 1
  })
  const rest = sum % 11
  return rest < 2 ? 0 : 11 - rest
}

const CNPJ_WEIGHTS_12 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
const CNPJ_WEIGHTS_13 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]

const calcCnpjDigit = (digits) => {
  const weights = digits.length === 12 ? CNPJ_WEIGHTS_12 : CNPJ_WEIGHTS_13
  const sum = digits.reduce((acc, digit, i) => acc + digit * weights[i], 0)
  const rest = sum % 11
  return rest < 2 ? 0 : 11 - rest
}

const onlyDigits = (value) => value.replace(/\D/g, '').split('').map(Number)

export const validateCpf = (value) => {
  const digits = onlyDigits(value)
  if (digits.length !== 11) return false
  if (digits.every((d) => d === digits[0])) return false
  const base = digits.slice(0, 9)
  const d1 = calcCpfDigit(base, 10)
  const d2 = calcCpfDigit([...base, d1], 11)
  return digits[9] === d1 && digits[10] === d2
}

export const validateCnpj = (value) => {
  const digits = onlyDigits(value)
  if (digits.length !== 14) return false
  if (digits.every((d) => d === digits[0])) return false
  const base = digits.slice(0, 12)
  const d1 = calcCnpjDigit(base)
  const d2 = calcCnpjDigit([...base, d1])
  return digits[12] === d1 && digits[13] === d2
}
